<template>
  <div class="card card-shadow" v-if="apiCalls.length > 0">
    <div class="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
      <h1 class="h4">{{ translate('tables.api-calls.title') }}</h1>
    </div>
    <div class="card-body p-0">
      <table class="table card-table table-hover mb-0">
        <thead class="thead-light">
        <tr>
          <th>#</th>
          <th>Status</th>
          <th>Type</th>
          <th>{{ translate('tables.columns.created') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="eachApiCall in apiCalls"
            :class="apiCall && (apiCall.id === eachApiCall.id) ? 'table-info' : ''"
            @click="showApiCall(eachApiCall.id)">
          <td>{{ eachApiCall.id }}</td>
          <td>{{ eachApiCall.status }}</td>
          <td>{{ eachApiCall.type }}</td>
          <td>{{ eachApiCall.created_at | datetime }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="alert alert-info w-50" role="alert">
    <span class="fa fa-info-circle mr-2"></span>{{ translate('tables.api-calls.empty') }}
  </div>
</template>

<script>
export default {
  props: ['apiCalls', 'apiCall'],

  mounted () {
    this.$parent.$emit('getApiCalls');
  },

  methods: {
    showApiCall (apiCallId) {
      this.$parent.$emit('getApiCall', apiCallId);
    },
  }
};
</script>
